// path: src/pages/IPA/Negociacoes/components/StageNotice/StageNotice.tsx
import { useSelector } from 'react-redux';
import { User } from '../../../../../@types';
import { Callout } from '../../../../../components/Callout';
import { selectorUser } from '../../../../../lib/selectorUser';
import { isProductRule } from '../../../../../utils/ipaAccess';
import { IMPLEMENTATION_STAGE, MAILTO_PREFIX, STAGE_NOTICE_EMAIL, STAGE_NOTICE_TEXTS } from './StageNotice.constants';

export type StageNoticeScreen = 'SUPPLIER' | 'SAVED';

export type StageNoticeContent =
  | { stage: typeof IMPLEMENTATION_STAGE.WITHOUT_INTEGRATION; beforeLink: string; email: string; afterLink: string }
  | { stage: typeof IMPLEMENTATION_STAGE.IN_INTEGRATION; text: string };

export const getStageNoticeContent = (user: User | null | undefined, screen: StageNoticeScreen): StageNoticeContent | null => {
  if (!isProductRule(user)) return null;
  const stage: string | null | undefined = user?.produtosIpa?.estagioImplantacao;
  if (stage === IMPLEMENTATION_STAGE.WITHOUT_INTEGRATION) {
    return { stage, email: STAGE_NOTICE_EMAIL, ...STAGE_NOTICE_TEXTS.withoutIntegration };
  }
  if (stage === IMPLEMENTATION_STAGE.IN_INTEGRATION) {
    return { stage, text: STAGE_NOTICE_TEXTS.inIntegration[screen] };
  }
  return null;
};

const renderDescription = (content: StageNoticeContent) => {
  if (content.stage === IMPLEMENTATION_STAGE.IN_INTEGRATION) return content.text;
  return (
    <>
      {content.beforeLink}
      <a data-testid="stage-notice-email-link" className="link-button link-button-small" href={MAILTO_PREFIX + content.email}>
        {content.email}
      </a>
      {content.afterLink}
    </>
  );
};

export type StageNoticeProps = { screen: StageNoticeScreen };

export const StageNotice = ({ screen }: StageNoticeProps) => {
  const user = useSelector(selectorUser);
  const content = getStageNoticeContent(user, screen);
  if (!content) return null;
  return (
    <Callout variant="warning" size="sm" data-testid="stage-notice" data-stage={content.stage}>
      <Callout.Description>{renderDescription(content)}</Callout.Description>
    </Callout>
  );
};
